import React from "react";
import ReactSelect, {
  mergeStyles,
  Props as ReactSelectProps,
} from "react-select";
import FluentReactSelectProps from "./props";
import { useTheme } from "styled-components";
import { IStyledTheme } from "../theme/types";

type Props = ReactSelectProps<any> & {
  selectRef?: any;
};

export const Select = (props: Props) => {
  const myTheme = useTheme() as IStyledTheme;
  let mergedStyles = FluentReactSelectProps.styles(myTheme);

  if (props.styles) {
    mergedStyles = mergeStyles(
      FluentReactSelectProps.styles(myTheme)!,
      props.styles
    );
  }

  let mergedComponents = FluentReactSelectProps.components;

  if (props.components) {
    mergedComponents = {
      ...mergedComponents,
      ...props.components,
    };
  }

  return (
    <ReactSelect
      isMulti={props.isMulti}
      {...props}
      styles={mergedStyles}
      theme={(theme) => {
        let mergedTheme = FluentReactSelectProps.theme(theme, myTheme);
        if (props.theme) {
          if (typeof props.theme === "function") {
            mergedTheme = {
              ...mergedTheme,
              ...props.theme(theme),
            };
          }
          //
          else {
            mergedTheme = {
              ...mergedTheme,
              ...props.theme,
            };
          }
        }
        return mergedTheme;
      }}
      components={mergedComponents}
      ref={props.selectRef}
    />
  );
};
